import type { APIReferenceType, ArdoqId, ArrowType } from '@ardoq/api-types';
import type { RepresentationData } from '@ardoq/data-model';

export type SimpleBlockDiagramLabels = {
  collapseAll: string;
  expandAll: string;
  zoomIn: string;
  zoomOut: string;
};

export enum SimpleBlockDiagramContentType {
  WORKSPACE_FOLDER = 'AssetFolder',
  WORKSPACE = 'Workspace',
  COMPONENT = 'Component',
  REFERENCE = 'Reference',
  FIELD = 'Field',
  REFERENCE_COMPLETENESS = 'Reference completeness',
  INVALID = 'Invalid',
}

type ElementId = string;

type GraphElement = {
  type: SimpleBlockDiagramContentType;
  /**
   * Id for node, edge or group in the graph
   *
   * Used for providing ids in callbacks and as targets for edges
   */
  id: ArdoqId;
  color: string | null;
  label: string;
  labelColor?: string;
};

export type SimpleBlockDiagramNode = GraphElement & {
  type: SimpleBlockDiagramContentType;
  parentId?: ElementId;
  representationData: RepresentationData | null;
  componentId?: ArdoqId;
};

export type SimpleBlockDiagramEdge = GraphElement & {
  type: SimpleBlockDiagramContentType.REFERENCE;
  referenceId?: ArdoqId;
  /**
   * Id for group or node this edge goes from
   */
  sourceId: ElementId;
  /**
   * Id for group or node this edge goes to
   */
  targetId?: ElementId;
  /**
   * Accepts all CSS border-style strings
   *
   * Will be converted to DashStyles by yFiles
   */
  line?: string;
  lineBeginning?: ArrowType;
  lineEnding?: ArrowType;
  referenceTypeName?: APIReferenceType['name'];
};

export type OnItemDoubleClick = (metaData: {
  elementType: SimpleBlockDiagramContentType;
  elementId: string;
  referenceId?: string;
}) => void;

export type OnItemFocus = (metaData: {
  elementType: SimpleBlockDiagramContentType;
  elementId: string;
  referenceId?: string;
}) => void;

export type IEdgeTag = {
  elementType: SimpleBlockDiagramContentType.REFERENCE;
  elementId: string;
  referenceId?: string;
  color: string | null;
  text: string;
  referenceTypeName?: string;
};
